import {connect} from 'react-redux'
import NavDrawer from '../components/NavBar/NavDrawer'

function mapStateToProps(state, props) {
  return {
    browser: state.browser
  }
}

export default connect(mapStateToProps)(NavDrawer)


// WEBPACK FOOTER //
// ./src/containers/NavDrawer.js